import type { Vacancy } from 'clients/AutoCompleteClient/types';

export type VacanciesListProps = {
  selectedVacancy: Vacancy | null;
  onCreateJob: () => void;
  onSelectVacancy: (vacancy: Vacancy) => void;
  onDeleteVacancy?: (vacancy: Vacancy) => void;
  onEditVacancy?: (vacancy: Vacancy) => void;
  vacanciesList: Vacancy[];
  showEnrichedVacancyButton?: boolean;
  disableTooltip?: boolean;
};

export enum VacancyListTab {
  AtsJobs = 'ats-jobs',
  IndeedJobs = 'indeed-jobs',
}
